export default "__VITE_ASSET__BqGVVvwD__"